(ns app.members.views
  (:require [app.components.headers.views :refer [header]]
            [app.dashboard.events :refer [get-token]]
            [app.endpoints :refer [strive-react-endpoint]]
            [app.members.styles :refer [members-table settings-panel]]
            [app.routes :as routes]
            [app.subs :as subs]
            [re-com.core :as re-com :refer [at v-box] :rename {input-text inputText}]
            [re-posh.core :as re-posh]
            [reagent.core  :as reagent :refer [atom]]))

(defn template-header []
  [v-box
   :src (at)
   :gap "8px"
   :children [[header {:label "Workspace members" :type :title :size :large}]
              [header {:label "If you’re the owner or admin of this workspace you can manage the permissions of each workspace member" :type :normal :size :regular}]]])

(defn tab-panel [{:keys [value children index]}]
  [:div {:role "tabpanel"
         :hidden (not= value index)
         :id (str "tab-panel-" index)
         :ariaLabelledby (str "tab-" index)
         :class (members-table)}
   (when (= value index)
     children)])

(defn members-view-panel [workspace-id]
  (let [token (get-token)
        workspace-members-route (str strive-react-endpoint "/folder/editor?token=" token "&workspace_id=" workspace-id)

        ;; text-val (reagent/atom nil)
        ;; tab-value (reagent/atom 0)
        ;; search-val (reagent/atom nil)
        ;; role-selected (reagent/atom "All")
        ;; {item-input-id :selected-workspace/id
        ;;  item-input-value :selected-workspace/name} @(re-posh/subscribe [::subs/selected-workspace-data])
        ;; members [{:name "Tala Tarazi"
        ;;           :email "tala.tarazi@hp.com"
        ;;           :profile-picture "https://lh3.googleusercontent.com/a-/AOh14GjW8wQOemAkfgY31LY4MIeq5pud_ShMaqOB4qKk=s96-c"
        ;;           :role "Admin"}
        ;;          {:name "Udi Vaks"
        ;;           :email "udi.vaks@hp.com"
        ;;           :profile-picture nil
        ;;           :role "Owner"}
        ;;          {:name "Avishay Sanker"
        ;;           :email "avishay.sanker@hp.com"
        ;;           :profile-picture nil
        ;;           :role "Collaborator"}
        ;;          {:name "Majd Jaber"
        ;;           :email "majd.jaber@hp.com"
        ;;           :profile-picture nil
        ;;           :role "Owner"}]
        ]
    (fn [] 
      [v-box
       :src      (at)
       :height "100vh"
       :size "auto"
       :gap "22px"
       :class (settings-panel)
       :children [[:iframe {:id "iframe" :style {:height "100%" :border "none"} :src workspace-members-route}]
;;TODO: replace to new view (this is old view)
                  ;; [template-header]
                  ;; [h-box
                  ;;  :gap "20px"
                  ;;  :children [[input-field {:placeholder "Email address" :disable false :value ""
                  ;;                           :onChange #(do (reset! text-val %)
                  ;;                                          (re-posh/dispatch
                  ;;                                           [::wevents/change-new-workspace item-input-id @text-val]))
                  ;;                           :height "12px"
                  ;;                           :width "286px"}]
                  ;;             [buttons/button {:action :cta :type :primary :title "Invite members" :size :medium :onClick #(println "test")}]]]
                  ;; [:div
                  ;;  {:class (members-container)}
                  ;;  [h-box
                  ;;   :justify :between
                  ;;   :align :center
                  ;;   :padding "0px 20px 0px 0px"
                  ;;   :children [[tabs {:value @tab-value
                  ;;                     :onChange (fn [_ value]
                  ;;                                 (reset! tab-value value))
                  ;;                     :ariaLabel "members-tab"
                  ;;                     :classes {:indicator (tab-root)
                  ;;                               :flexContainer (tab-container)}}
                  ;;               [tab {:label (str "Members (" (count members) ")") :id (str "tab-" 0) :ariaControls (str "tab-panel-" 0)}]
                  ;;               [tab {:label "Guests" :id (str "tab-" 1) :ariaControls (str "tab-panel-" 1)}]]
                  ;;              [members-role-menu {:role-selected  role-selected}]]]
                  ;;  [:div
                  ;;   [search-bar-field
                  ;;    {:placeholder "Search by name or email"
                  ;;     :value @search-val
                  ;;     :width "100%"
                  ;;     :height "54px"
                  ;;     :onChange #(reset! search-val %)}]]
                  ;;  [tab-panel {:value @tab-value
                  ;;              :index 0
                  ;;              :children [:div
                  ;;                         (map
                  ;;                          (fn [{:keys [name email profile-picture role]}]
                  ;;                            ^{:key email}
                  ;;                            [h-box
                  ;;                             :src (at)
                  ;;                             :justify :between
                  ;;                             :padding "15px 20px"
                  ;;                             :style {:background-color "white"
                  ;;                                     :border-bottom "1px solid #E0DFE4"}
                  ;;                             :children [[h-box
                  ;;                                         :src (at)
                  ;;                                         :gap "10px"
                  ;;                                         :align :center
                  ;;                                         :children [(if (nil? profile-picture)
                  ;;                                                      [:div
                  ;;                                                       {:class (avatar-style)}
                  ;;                                                       [:span (get (first (split name #" ")) 0)]
                  ;;                                                       [:span (get (last (split name #" ")) 0)]]
                  ;;                                                      [avatar {:src profile-picture :size "48px"}])
                  ;;                                                    [v-box
                  ;;                                                     :src (at)
                  ;;                                                     :justify :center
                  ;;                                                     :children [[header {:label name :type :small :size :bold}]
                  ;;                                                                [header {:label email :type :small :size :regular}]]]]]
                  ;;                                        [members-role-switch-menu {:role-selected (reagent/atom role) :email email}]]])

                  ;;                          (if (nil? @search-val)
                  ;;                            (if (not= @role-selected "All")
                  ;;                              (filter #(= (:role %) @role-selected) members)
                  ;;                              members)
                  ;;                            (if (not= @role-selected "All")
                  ;;                              (filter #(and (= (:role %) @role-selected) (or (includes? (:name %) @search-val) (includes? (:email %) @search-val))) members)
                  ;;                              (filter #(or (includes? (:name %) @search-val) (includes? (:email %) @search-val)) members))))]}]
                  ;;  [tab-panel {:value @tab-value
                  ;;              :index 1
                  ;;              :children [h-box
                  ;;                         :src (at)
                  ;;                         :justify :between
                  ;;                         :padding "15px 20px"
                  ;;                         :style {:background-color "white"
                  ;;                                 :border-bottom "1px solid #E0DFE4"}
                  ;;                         :children [[h-box
                  ;;                                     :src (at)
                  ;;                                     :gap "10px"
                  ;;                                     :align :center
                  ;;                                     :children [[avatar {:src "https://lh3.googleusercontent.com/a-/AOh14GjW8wQOemAkfgY31LY4MIeq5pud_ShMaqOB4qKk=s96-c"}]
                  ;;                                                [v-box
                  ;;                                                 :src (at)
                  ;;                                                 :justify :center
                  ;;                                                 :children [[header {:label (str "Tala Tarazi" @tab-value) :type :small :size :bold}]
                  ;;                                                            [header {:label "tala.tarazi@hp.com" :type :small :size :regular}]]]]]
                  ;;                                    [h-box
                  ;;                                     :src (at)
                  ;;                                     :gap "4px"
                  ;;                                     :justify :center
                  ;;                                     :align :center
                  ;;                                     :children [[header {:label "Admin" :type :normal :size :regular}]
                  ;;                                                [chevron-down-icon]]]]]}]]
                  ]])))

(defmethod routes/panels :members-view-panel [] [members-view-panel])